var ModalType;
(function (ModalType) {
    ModalType["Account"] = "Account";
    ModalType["AccountLogged"] = "AccountLogged";
    ModalType["Search"] = "Search";
    ModalType["Language"] = "Language";
    ModalType["Currency"] = "Currency";
    ModalType["ShoppingCart"] = "ShoppingCart";
})(ModalType || (ModalType = {}));

export { ModalType as M };
//# sourceMappingURL=modal-6vnX5SO3.js.map
